<div class="cascader-wrapper">
  <label class="col-form-label p-0">
    {{ label }}
  </label>
  
  <!-- Trigger -->
  <div
        (click)="toggleOpen()"
        class="form-control d-flex align-items-center justify-content-between border-0 ps-0"
        [class.cursor-pointer]="!disabled"
        [class.disabled]="disabled"
        [ngClass]="(isOpen() ? 'border-primary ring-2 ' : '') + customClass"
      >
        <div class="d-flex align-items-center overflow-hidden flex-grow-1 trigger-content">
          <!-- <div class="d-flex align-items-center justify-content-center flex-shrink-0 bg-light rounded icon-wrapper">
            <app-icon name="building-2" [size]="18" class="text-secondary"></app-icon>
          </div> -->

          <div class="overflow-hidden d-flex flex-column justify-content-center category-info">
            <div class="text-truncate text-primary" *ngIf="leaf(); else emptyState">
              {{ leaf() }}
            </div>
            
            <div class="text-truncate text-muted mt-25 parent-breadcrumb" *ngIf="parentString()">
              {{ parentString() }}
            </div>

            <ng-template #emptyState>
              <div class="text-truncate text-muted">Select category...</div>
            </ng-template>
          </div>
        </div>

        <button
          *ngIf="hasSelection() && !disabled"
          type="button"
          class="btn btn-link p-0 me-50 clear-selection-btn text-muted"
          (click)="clearSelection($event)"
          aria-label="Clear selection"
        >
          <app-icon name="x" [size]="14"></app-icon>
        </button>

        <app-icon 
          name="chevron-right"
          [size]="14" 
          class="transition-transform flex-shrink-0"
          [style.transform]="isOpen() ? 'rotate(0deg)' : 'rotate(90deg)'"
        ></app-icon>
      </div>

  <div *ngIf="isOpen()" class="dropdown-menu show w-100 mt-75 p-0 animate-fade-in cascader-dropdown">
    
    <div class="d-flex align-items-center px-2 py-1 border-bottom bg-light">
      <div class="d-flex align-items-center justify-content-center back-button-wrapper">
        <button 
          *ngIf="viewLevel() > 0"
          (click)="handleBack($event)"
          class="btn btn-sm btn-link border-0 p-0 d-flex align-items-center justify-content-center text-secondary back-button"
        >
          <app-icon name="chevron-left" [size]="14"></app-icon>
        </button>
      </div>
    
      <span class="flex-grow-1 text-center text-uppercase fw-semibold text-secondary header-title">
        {{ getHeaderTitle() }}
      </span>
      <div class="spacer"></div>
    </div>

    <div class="overflow-auto custom-scrollbar items-container">
      <button 
        *ngFor="let item of currentItems()"
        (click)="handleSelection($event, item)"
        class="dropdown-item d-flex align-items-center justify-content-between px-2 py-1 dropdown-item-custom"
      >
        <div class="d-flex align-items-center item-content">
          <app-icon *ngIf="viewLevel() === 0" name="globe" [size]="14" class="text-secondary"></app-icon>
          <app-icon *ngIf="viewLevel() === 1" name="map-pin" [size]="14" class="text-secondary"></app-icon>
          <app-icon *ngIf="viewLevel() === 2" name="building-2" [size]="14" class="text-secondary"></app-icon>
          
          <span>{{ item.category_name }}</span>
        </div>
        <app-icon *ngIf="item.children && item.children.length > 0" name="chevron-right" [size]="12" class="text-muted"></app-icon>
      </button>
    </div>

    <div 
      *ngIf="getBreadcrumbPath().length > 0" 
      class="px-2 py-1 bg-light border-top text-muted breadcrumb-footer"
    >
      {{ getBreadcrumbPath() }}
    </div>
  </div>
</div>
